import { PerformanceStartReviewProcessValidatorFailedCheckEnum } from 'generated/resources/graphql'

export const validationChecker = (
  startValidationErrors: PerformanceStartReviewProcessValidatorFailedCheckEnum[],
  errorType: PerformanceStartReviewProcessValidatorFailedCheckEnum
) => {
  return startValidationErrors.includes(errorType)
}
